export const messages = {
  en: {
    menuCatalog: {
      search: {
        title: 'Search Condition',
        name: 'name',
        icon: 'icon',
        seq: 'seq',
        storeType: 'storeType',
        url: 'url',
        isShow: 'isShow',
        createTime: 'createTime',
        placeholder: 'Please enter menuCatalog name'
      },
      list: {
        title: 'menuCatalog List'
      },
      dialog: {
        addTitle: 'Add MenuCatalog',
        editTitle: 'Edit MenuCatalog',
        delTitle: 'Delete MenuCatalog',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        caId: 'caId',
        name: 'name',
        icon: 'icon',
        seq: 'seq',
        storeType: 'storeType',
        url: 'url',
        isShow: 'isShow',
        createTime: 'createTime',
      },
      table: {
        caId: 'caId',
        name: 'name',
        icon: 'icon',
        seq: 'seq',
        storeType: 'storeType',
        url: 'url',
        isShow: 'isShow',
        createTime: 'createTime',
      },
      validate: {
        caId: 'Please enter caId',
        name: 'Please enter name',
        icon: 'Please enter icon',
        seq: 'Please enter seq',
        url: 'Please enter url',
        isShow: 'Please enter isShow',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add MenuCatalog success'
      },
      edit: {
        success: 'Edit MenuCatalog success'
      },
      delete: {
        success: 'Delete MenuCatalog success',
        confirm: 'Are you sure to delete this menuCatalog?'
      },
      fetchError: 'Failed to fetch menuCatalog list',
      menuGropBtn:'menu group'
    }
  },
  zh: {
    menuCatalog: {
      search: {
        title: '查询条件',
        name: '菜单组名称',
        icon: '图标',
        seq: '顺序',
        storeType: '商户类型',
        url: '页面',
        isShow: '是否显示',
        createTime: '创建时间',
        placeholder: '请输入菜单目录名称'
      },
      list: {
        title: '菜单目录'
      },
      dialog: {
        addTitle: '添加菜单目录',
        editTitle: '编辑菜单目录',
        delTitle: '删除菜单目录',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        caId: '目录名称',
        name: '菜单组名称',
        icon: '图标',
        seq: '顺序',
        storeType: '商户类型',
        url: '页面',
        isShow: '是否显示',
        createTime: '创建时间',
      },
      table: {
        caId: '目录名称',
        name: '菜单组名称',
        icon: '图标',
        seq: '顺序',
        storeType: '商户类型',
        url: '页面',
        isShow: '是否显示',
        createTime: '创建时间',
      },
      validate: {
        caId: '请输入目录名称',
        name: '请输入菜单组名称',
        icon: '请输入图标',
        seq: '请输入顺序',
        url: '请输入页面',
        isShow: '请输入是否显示',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加菜单目录成功'
      },
      edit: {
        success: '编辑菜单目录成功'
      },
      delete: {
        success: '删除菜单目录成功',
        confirm: '确认删除该菜单目录吗？'
      },
      fetchError: '获取菜单目录列表失败',
      menuGropBtn:'菜单组'
    }
  }
}